import React from "react";

import { faExclamationTriangle } from "@fortawesome/pro-solid-svg-icons/faExclamationTriangle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Col from "antd/es/col";
import Tooltip from "antd/es/tooltip";
import { useIntl } from "react-intl";

import { Company, Person } from "@mapmycustomers/shared/types/entity";

import Address from "@app/component/field/Address";

import styles from "./GeoLocationInfo.module.scss";
import useGeocodeInfo from "./util/useGeocodeInfo";

interface Props {
  entity: Company | Person;
}

const GeoLocationInfo: React.FC<Props> = ({ entity }) => {
  const intl = useIntl();

  const hasAddress = !!entity.address || !!entity.geoPoint?.coordinates;

  const geocodeTooltipText = useGeocodeInfo(intl, entity?.geoStatus);

  return (
    <div className={styles.container}>
      {geocodeTooltipText && (
        <Col>
          <Tooltip title={geocodeTooltipText}>
            <FontAwesomeIcon className={styles.geocodeIcon} icon={faExclamationTriangle} />
          </Tooltip>
        </Col>
      )}
      <Col>
        {hasAddress ? (
          <Address entity={entity} showWarning />
        ) : (
          <>
            <div>
              {intl.formatMessage({
                id: "companyPreview.location.noAddressForEntity",
                defaultMessage: "No Address",
                description:
                  "Address text when no address is available in Location section in Company Preview pane",
              })}
            </div>
          </>
        )}
      </Col>
    </div>
  );
};

export default GeoLocationInfo;
